export const OPEN_USER_CONVERSATION = "OPEN_USER_CONVERSATION" as const;
export const MINIMIZE_USER_CONVERSATION = "MINIMIZE_USER_CONVERSATION" as const;
export const CLOSE_USER_CONVERSATION = "CLOSE_USER_CONVERSATION" as const;

export const openUserConversation = (id: string, objectType: string) => ({
  type: OPEN_USER_CONVERSATION,
  id: id,
  objectType: objectType,
});
export type OpenUserConversationAction = ReturnType<
  typeof openUserConversation
>;

export const minimizeUserConversation = (id: string, objectType: string) => ({
  type: MINIMIZE_USER_CONVERSATION,
  id: id,
  objectType: objectType,
});
export type MinimizeUserConversationAction = ReturnType<
  typeof minimizeUserConversation
>;

export const closeUserConversation = (id: string) => ({
  type: CLOSE_USER_CONVERSATION,
  id: id,
});
export type CloseUserConversationAction = ReturnType<
  typeof closeUserConversation
>;
